import React, { useEffect, useState,useMemo } from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { AlertComponent } from "../../common/components";
import { getEmailLetterTemplates } from "../../api/email-letter-templates";
import { PreviewTemplatesListProps } from "./email-letter-types";
import { useSetLoading } from "../../common/hooks/appearance";

interface Template {
  id: number;
  name: string;
  previewImage: string;
}

const PreviewTemplatesList: React.FC<PreviewTemplatesListProps> = ({
  handleOnClickTemplate,
  sortBy = "date",
  gridSize = 3,
}) => {
  // Sample template data - replace with your actual data
  const [templates, setTemplates] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);

  const fetchEmailTemplates = async (
    search: string = "",
    filters: any = {}
  ) => {
    setLoading(true);
    try {
      const params: any = {
        fetchAll: true,
      };
      if (filters?.folderId) {
        if (filters.folderId !== "all" && filters.folderId !== "notInFolder") {
          params.folderId = Number(filters.folderId);
        }
        if (filters.folderId === "notInFolder") {
          params.notInFolder = true;
        }
      }
      if (search) {
        params.searchText = search;
      }
      if (sortBy) {
        params.sortBy = sortBy
        if(sortBy === "name")
        params.sortDirection="asc"
      }
      params.templateType = "Email";
      const response = await getEmailLetterTemplates(params);
      setTemplates(response.data.data.result);
      setLoading(false);
    } catch (error: any) {
      console.error("Error fetching email templates:", error);
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch email templates."
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmailTemplates();
  }, [sortBy]);

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <Box className="preview-templates-list" sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        {templates.map((template) => (
          <Grid
            item
            xs={12} // Mobile: 1 per row
            sm={gridSize+1} // Tablet: 3 per row 12/(3+1)=3 12/(2+1)=4
            md={gridSize} // Desktop: 4 per row (12/3 = 4 12/2 = 6)
            key={template.id}
          >
            <Card
              className="template-preview-card"
              onClick={() => {
                handleOnClickTemplate(template);
              }}
            >
              {template?.preview_url_s3 ? <CardMedia
                component="img"
                image={template?.preview_url_s3}
                alt={template.name}
                className="template-preview-image"
               
              /> : <Card className="template-preview-image" />
              }
              <p className="template-name" title={template?.name}>
                {template.name}
              </p>
            </Card>
          </Grid>
        ))}
      </Grid>
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </Box>
  );
};

export default PreviewTemplatesList;
